import { type MaterialCommunityIconName } from "@/schemas/icons";
import { type LinkType } from "@/schemas/links/web";

export type SocialMediaIcon = {
  platform: LinkType;
  iconName: MaterialCommunityIconName;
  color: string;
};

export const SOCIAL_MEDIA_ICONS: Record<LinkType, SocialMediaIcon> = {
  facebook: {
    platform: "facebook",
    iconName: "facebook",
    color: "#1877F2",
  },
  instagram: {
    platform: "instagram",
    iconName: "instagram",
    color: "#E4405F",
  },
  twitter: {
    platform: "twitter",
    iconName: "twitter",
    color: "#1DA1F2",
  },
  youtube: {
    platform: "youtube",
    iconName: "youtube",
    color: "#FF0000",
  },
  website: {
    platform: "website",
    iconName: "web",
    color: "#4285F4",
  },
  tiktok: {
    platform: "tiktok",
    iconName: "music-note",
    color: "#69C9D0",
  },
};
